import { defineComponent as _defineComponent } from 'vue'
import { reactive } from 'vue';
import ChevronIcon from '@/icons/ChevronIcon.vue';

interface SidebarItem {
    label: string;
    icon?: string;
    href?: string;
    children?: SidebarItem[];
}

interface Props {
    items: SidebarItem[];
    active?: string;
    isCollapsed?: boolean;
    level?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItemGroup',
  props: {
    items: null,
    active: { default: '' },
    isCollapsed: { type: Boolean, default: false },
    level: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { items: SidebarItem[], active: string, isCollapsed: boolean, level: number };



const expandedManual = reactive<Record<number, boolean>>({});

function isActive(href?: string): boolean {
    if (!href) return false;
    return (props.active && props.active.startsWith(href) && props.level === 0) || props.active === href;
}

function hasActiveChild(item: SidebarItem): boolean {
    if (!item.children) return false;
    return item.children.some(child => {
        if (isActive(child.href)) return true;
        if (child.children) return hasActiveChild(child);
        return false;
    });
}

function isExpanded(index: number): boolean {
    // Auto-expand si hay un hijo activo
    if (hasActiveChild(props.items[index])) {
        return true;
    }
    // Si no, usa el estado manual
    return expandedManual[index] || false;
}


return { __sfc: true,props, expandedManual, isActive, hasActiveChild, isExpanded, ChevronIcon }
}

})